var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OrderList',{attrs:{"orders":_vm.orders,"step":50,"length":50}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }